import { render, staticRenderFns } from "./reviewEdit.vue?vue&type=template&id=d51bb0a2&scoped=true&"
import script from "./reviewEdit.vue?vue&type=script&lang=js&"
export * from "./reviewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51bb0a2",
  null
  
)

export default component.exports